import { Capacitor } from '@capacitor/core'
import { Deploy } from 'cordova-plugin-ionic'

export const getPlatform = (): string => {
  return Capacitor.getPlatform()
}

export const isPlatformWeb = (): boolean => {
  return getPlatform() === 'web'
}

export const isPlatformNative = (): boolean => {
  return Capacitor.isNativePlatform()
}

export const allowPwaInstall = (): boolean => {
  const forcePwa = `${process.env.REACT_APP_FORCE_PWA_ON_MOBILE_BROWSERS}` === 'true'
  return forcePwa || !isMobileBrowser()
}

export const getIonicConfig = async () => {
  return await Deploy.getConfiguration()
}

export const getUserAgent = () => {
  return navigator?.userAgent
}

const isMobileUA = (ua: string): boolean => {
  return /(iPhone|Android|iPad|iPod)/i.test(ua)
}

const isIPad = (ua: string, maxTouchPoints: number) => {
  return ua.includes('macintosh') && maxTouchPoints >= 1
}

export const isMobileBrowser = (): boolean => {
  if (isPlatformNative()) return false
  const ua = navigator.userAgent.toLowerCase() || ''
  const maxTouchPoints = (navigator as Navigator)?.maxTouchPoints || 0
  if (isIPad(ua, maxTouchPoints)) return true
  return isMobileUA(ua) && maxTouchPoints >= 1
}

export const getSourceType = (): string => {
  if (isPlatformWeb()) return 'pwa'
  else return Capacitor.getPlatform()
}
